import useConfigController from '@api/useConfigController'
import React, { createContext, useContext } from 'react'

const ConfigContext = createContext<Partial<Interfaces.Config>>({})
const useConfigContext = () => useContext(ConfigContext)

export default function ConfigProvider({ children }: React.PropsWithChildren<{}>) {
    const controller = useConfigController()
    const { data: config } = controller.show().use()
    return <ConfigContext.Provider value={config || {}}>{children}</ConfigContext.Provider>
}

export { useConfigContext }
